export enum ClassAttributeType {
  Numeric = 'numeric',
  Bool = 'bool',
}
